import { render, staticRenderFns } from "./EditPriceDialog.vue?vue&type=template&id=1c1db664"
import script from "./EditPriceDialog.vue?vue&type=script&lang=js"
export * from "./EditPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports